// extracted by mini-css-extract-plugin
export default {"card":"JY-z","carouselContainer":"KY-z","carouselContent":"LY-z"};